// extracted by mini-css-extract-plugin
export default {"container":"EditTruck_container__RtYBP","buttongroup":"EditTruck_buttongroup__TwO4c"};